import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@ui-nuvertos/shared';

/**
 * Module names accepted by the generic related-documents endpoint.
 * Must match the registry in the backend service
 * (service-nuvertos/libs/utils/related_documents).
 */
export type RelatedDocumentsModule =
  | 'vendor-po'
  | 'vendor-invoice'
  | 'vendor-debit-note'
  | 'client-order'
  | 'client-invoice'
  | 'client-credit-note';

/** A single related-document row as returned by the backend. */
export interface RelatedDocument {
  document_type: string;
  document_number: string | null;
  document_id: string | number;
  posting_date: string | null;
  document_date: string | null;
  subsidiary_name: string | null;
  location_name: string | null;
}

/** Envelope returned by GET /related-documents/:module/:id. */
export interface RelatedDocumentsResponse {
  status?: string;
  message?: string;
  data: { related_documents: RelatedDocument[] };
}

@Injectable({
  providedIn: 'root'
})
export class RelatedDocumentsService {
  private accountingUrl = environment.accountingUrl;

  constructor(private http: HttpClient) {}

  /**
   * Get related documents for any supported module.
   * Endpoint: GET /api/v1/related-documents/:module/:id
   */
  getRelatedDocuments(
    module: RelatedDocumentsModule,
    id: string | number
  ): Observable<RelatedDocumentsResponse> {
    const url = `${this.accountingUrl}/api/v1/related-documents/${module}/${id}`;
    return this.http.get<RelatedDocumentsResponse>(url, { withCredentials: true });
  }
}
